function openNewsletterModal()
{
    MicroModal.show('modal-popup-newsletter', {
        disableScroll: true,
        openClass: '!block',
    })
}

var newsletterHidden = true;
function showNewsletterHidden()
{
    console.log('showNewsletterHidden');
    document.querySelectorAll('.js-newsletter-hidden').forEach((v2, k2) => {
        v2.classList.remove('force-newsletter-hidden');
    });
}

document.addEventListener("d365mkt-afterformload", function(event) {
    if (event.target.getAttribute('data-copiaincolla-type') == 'newsletter') {
        console.log("d365mkt-afterformload", event.target.getAttribute('data-copiaincolla-type'));

        document.querySelectorAll('[data-copiaincolla-type="newsletter"] input[type="text"], [data-copiaincolla-type="newsletter"] input[type="email"]').forEach((v, k) => {
            v.setAttribute('placeholder', v.getAttribute('placeholder')+'*')
        });
        document.querySelectorAll('[data-copiaincolla-type="newsletter"] [name="firstname"], [data-copiaincolla-type="newsletter"] [name="lastname"]').forEach((v, k) => {
            v.parentNode.classList.add('force-newsletter-hidden');
            v.parentNode.classList.add('js-newsletter-hidden');
        });
        document.querySelectorAll('[data-copiaincolla-type="newsletter"] .consentBlock, [data-copiaincolla-type="newsletter"] .submitButtonWrapper').forEach((v, k) => {
            v.classList.add('force-newsletter-hidden');
            v.classList.add('js-newsletter-hidden');
        });

        document.querySelectorAll('[data-copiaincolla-type="newsletter"] [name="emailaddress1"]').forEach((v, k) =>  {
            v.addEventListener('click', function () {
                console.log('emailaddress1 click');
                if (newsletterHidden) {
                    showNewsletterHidden();
                    newsletterHidden = false;
                }
            });
            v.addEventListener('change', function () {
                console.log('emailaddress1 change');
                if (newsletterHidden) {
                    showNewsletterHidden();
                    newsletterHidden = false;
                }
            });
            v.addEventListener('paste', function () {
                console.log('emailaddress1 change');
                if (newsletterHidden) {
                    showNewsletterHidden();
                    newsletterHidden = false;
                }
            });
            v.addEventListener('keyup', function () {
                console.log('emailaddress1 change');
                if (newsletterHidden) {
                    showNewsletterHidden();
                    newsletterHidden = false;
                }
            });
        });

        if (
            getCookie('newsletter_ok')
            || getCookie("newsletter_close")
            || route == 'app_contact'
            || route == 'app_landing_show'
            || route == 'admin_preview_landing'
        ) {
        } else {
            setTimeout(function () {
                openNewsletterModal();
            }, 5000);
        }
    }
});

document.addEventListener("d365mkt-afterformsubmit", function(event) {
    // console.log(event);
    // console.log(event.target);
    // console.log(event.target.parentNode);
    // console.log(event.detail.payload);
    // console.log("success - " + event.detail.successful);

    if (event.detail.successful && event.target.parentNode.getAttribute('data-copiaincolla-type') == 'newsletter') {

        console.log("d365mkt-afterformsubmit", event.target.parentNode.getAttribute('data-copiaincolla-type'));

        var data = decodeDynamicsPayload(event.detail.payload.fields);

        var event_id = uniqueId('pixel');
        // var now = Math.floor(Date.now() / 1000);
        // pixel_trackAPIConversion('CompleteRegistration', event_id, getCookie('_fbp'), getCookie('_fbc'), now);
        var consense = JSON.parse(data["consentsubmissionvalues"]);
        // console.log('consense', consense);

        if (consense.msdynmkt_value == 'Opted In') {
            dataLayer.push({ event_id: event_id, 'event': 'newsletter_send' });
        }

        setCookie('newsletter_ok', 1, 90);
    }
});